import { descending } from 'd3';

export default () => (dispatch, getState) => {

  const { token, wtRegion, clientEmail } = getState();

  const url = `${process.env.REACT_APP_API_URL}/personalstrategies/`;
  fetch(`${url}?wtRegion=${wtRegion}&clientEmail=${clientEmail}`, { 
    headers: {
      Authorization: token &&
        `Token ${token}`,
    }
  })
    .then(d => {
      if(d.status >= 400){
        return;
      }      
        return d.json().then(response => {

          const sortedData = [...response]
            .filter(p => !!p.holdings)
            .sort(
              (a, b) =>
                descending(new Date(a.updateDate), new Date(b.updateDate))
            );
          dispatch({ type: 'LOAD_PERSONAL_STRATEGIES', personalStrategies: sortedData })
        })
    })
    .catch(error => {
      console.error(error);
    });
};



// WEBPACK FOOTER //
// ./src/actions/query-api/personal-strategies.js